import { axiosClient } from "./axiosClient";

export interface OfferFilters {
  status?: 'pending' | 'accepted' | 'declined' | 'counter_offered' | 'expired' | 'withdrawn';
  offerType?: 'cash' | 'exchange';
  cursor?: string;
  limit?: number;
}

// Fetch all offers (admin only)
export const fetchOffers = async (filters: OfferFilters) => {
  const { data } = await axiosClient.get('/marketplace/offers/admin/all', { params: filters });
  return data;
};

// Delete offer (admin only)
export const deleteOffer = async (offerId: string, reason: string) => {
  const { data } = await axiosClient.delete(`/marketplace/offers/admin/${offerId}`, {
    data: { reason },
  });
  return data;
};
